import script from "./DetailsPEL.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailsPEL.vue?vue&type=script&setup=true&lang=ts"

import "./DetailsPEL.vue?vue&type=style&index=0&id=96f03b7c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-96f03b7c"]])

export default __exports__